import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-post-guide',
  templateUrl: './post-guide.component.html',
  styleUrls: ['./post-guide.component.css']
})
export class PostGuideComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
